import React, { FC, PropsWithChildren } from 'react';

import KitHelmet from './KitHelmet';

export interface KitPageProps extends PropsWithChildren {
  title: string;
  titleTemplate?: string;
  locale: string;
}

const KitPage: FC<KitPageProps> = ({ title, titleTemplate, locale, children }) => {
  return (
    <>
      <KitHelmet locale={locale} title={title} titleTemplate={titleTemplate} />
      {children}
    </>
  );
};

export default KitPage;
